import { useEffect, useState } from 'react';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
  getAuthenticationLoading,
  getAuthenticationStatus,
} from '../../../../corelogic/state/authentication/authentication.selector';
import { store } from '../../../../corelogic/state/store';

// Authentication Hook
export const useAuthentication = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => store.getState().authentication.isAuthenticated,
  );
  const [isLoading, setIsLoading] = useState(
    () => store.getState().authentication.isLoading,
  );

  useEffect(() => {
    const isAuthenticated$ = store.select(getAuthenticationStatus);
    const isLoading$ = store.select(getAuthenticationLoading);

    const subscription = isAuthenticated$
      .pipe(distinctUntilChanged(), debounceTime(100))
      .subscribe((isAuth: boolean) => {
        console.log('Auth state changed:', isAuth);
        setIsAuthenticated(isAuth);
      });

    const loadingSubscription = isLoading$
      .pipe(distinctUntilChanged(), debounceTime(100))
      .subscribe((isLoading: boolean) => {
        setIsLoading(isLoading);
      });

    return () => {
      subscription.unsubscribe();
      loadingSubscription.unsubscribe();
    };
  }, []);

  return { isAuthenticated, isLoading };
};
